import router from '@/router';
/**
 * 请在页面引入  <script src="http://res.wx.qq.com/open/js/jweixin-1.4.0.js" type=""></script>
 * config.jsApiList 默认是，如需调用其他接口，需手动添加 ['scanQRCode'] 种的api https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#50
 * 
 * 页面调用
 * 
 * mounted 里面 this.$wechartfunc();
 * 在需要调用接口时 再次调用 this.$wechartfunc(argument);
 * argument 请参考 https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#50
 */

const params:any = {
    appId: 'wx25d3e5295d1ca5f0',
    grantType: 'jsapi',
    url: ''
};
const wx: any = (window as any).wx;
let config: any = {
    appId: '',
    nonceStr: '',
    signature: '',
    timestamp: '',
    url: '',
}
let status:boolean = false;
let action = '';

function isIOS () {
    const u:any = navigator.userAgent;
    const app:any = navigator.appVersion;
    const isAndroid:any = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
    const isIOS:any = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        // 这个是安卓操作系统
       return false
    }
    if (isIOS) {
　　　　  // 这个是ios操作系统
        return true
    }
}
function isAndroid () {
    const u:any = navigator.userAgent;
    const app:any = navigator.appVersion;
    const isAndroid:any = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
    const isIOS:any = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        // 这个是安卓操作系统
       return true
    }
    if (isIOS) {
　　　　  // 这个是ios操作系统
        return false
    }
}

export default function (act?: any) {
    action = act;
    if (((params.url === window.location.href) && status) || ((window.sessionStorage.getItem('isIOS') === '1') && status)) {
        switch (action) {
            case 'scanQRCode':
                return scanQRCode();
            default:
                return true;
        }
    } else {
        if (isIOS() && window.sessionStorage.getItem('isIOS') !== '1') {
            window.sessionStorage.setItem('isIOS', '1'); // ios 第一次进入项目需进行初始化config
            getJssdk();
        } else if (!isIOS()) {
            getJssdk();
        }
    }

    async function getJssdk() {
        params.url = window.location.href;
        const { error, success }: any = await router.app.$request('WX_JS_SDK', params);
        if (success && success.data) {
            config = success.data;
            status = true;
            delete config['url'];
            
            config.debug = false;
            config.jsApiList = ['scanQRCode'];
            wx.config(config);

            wx.ready(function(){
                console.log('ready');
                // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
                switch (action) {
                    case 'scanQRCode':
                        return scanQRCode();
                    default:
                        return true;
                }
            });
        }
    };

     function scanQRCode () {
        // return wx.scanQRCode({
        //     needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        //     scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        //     success: await function (res:any) {
        //         return res.resultStr; // 当needResult 为 1 时，扫码返回的结果
        //     }
        // });

        const promise = new Promise(function(resolve, reject){

            wx.scanQRCode({
                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                success: function (res:any) {
                    resolve(res.resultStr);
                }
            });
        
          });
          return promise
    }

    
}